export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return "0 Байтов";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["БТ", "КБ", "МБ", "ГБ", "ТБ"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const resultNumber = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  const resultText = sizes[i] === "БТ" ? getDeclension("байт", resultNumber) : sizes[i];

  return resultNumber + " " + resultText;
}

export function getDeclension(text: string, number: number) {
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits > 10 && lastTwoDigits < 20) {
    return `${text}ов`;
  }
  if (lastDigit > 1 && lastDigit < 5) {
    return `${text}а`;
  }
  if (lastDigit === 1) {
    return text;
  }
  return `${text}ов`;
}
